import { getAPIConfig } from '../../../utils';
import { executeExternalAPICall, executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';
import { getFormattedError, ServiceResponseError } from '../../../utils/errorMessage.util';

const getPaySecureErrorCode = (res, isExternalClient) => {
  const { body = {} } = res;
  const { data = {} } = body;
  const { ErrorCode } = isExternalClient ? body : data;
  return ErrorCode;
};

const responseHandler = (res, isExternalClient) => {
  const errorCode = getPaySecureErrorCode(res, isExternalClient);
  if (errorCode === '00') {
    const { body = {} } = res;
    const { data = {} } = body;
    return isExternalClient ? body : data;
  }
  throw new ServiceResponseError(res);
};

export const fetchPaySecureSessionId = () => {
  const payload = {
    webService: endpoints.getPaySecureClientToken,
  };

  return executeStatefulAPICall(payload, null, true)
    .then(responseHandler)
    .catch((err) => {
      throw getFormattedError(err, []);
    });
};

export const tokenizeCard = (sessionId, cardDetails, billingAddress, errorMapping = {}) => {
  const { accountNo, expMonth, expYear, cvv } = cardDetails;
  const webService = endpoints.tokenizeCard;
  const { paySecureUrl } = getAPIConfig();
  const { addressLine1, addressLine2, city, state, country, zipCode } = billingAddress;
  const expMonthInMM = expMonth.length === 1 ? `0${expMonth}` : expMonth;
  const expYearInYY = expYear.toString().substr(2, 2);
  const internationalCountry = country?.toLowerCase() !== 'us' && country?.toLowerCase() !== 'ca';
  const payload = {
    body: {
      SessionId: sessionId,
      CardNumber: accountNo?.replace(/ /g, ''),
      Expiration: `${expMonthInMM}${expYearInYY}`,
      CVN: cvv,
      ...(internationalCountry
        ? {}
        : {
            AVS: {
              Address: `${addressLine1}${addressLine2 || ''}`,
              City: city,
              State: state,
              Zip: zipCode,
              Country: country,
            },
          }),
    },
    webService: {
      ...webService,
      URI: `${paySecureUrl}/${webService.URI}`,
    },
  };

  return executeExternalAPICall(payload)
    .then((res) => responseHandler(res, true))
    .catch((err) => {
      if (err.response.body.ErrorCode === '606') {
        return {
          SESSION_ID_HAS_BEEN_EXPIRED: true,
        };
      }
      throw getFormattedError(err, errorMapping);
    });
};
